export default "/images/vendor/@coreui/icons/svg/flag/cif-cg.svg?9c6f31c8f73082877dce70b574f265e1";